export type SettingsTab = 'general' | 'security' | 'install' | 'backup' | 'api'
type Access = { isSuperAdmin:boolean; can:(permission?:string)=>boolean }
export function settingsTabs(auth:Access):SettingsTab[] {
  return [...(auth.isSuperAdmin ? ['general','security'] as const : []), ...(auth.can('provisioning:install:create') ? ['install'] as const : []), ...(auth.isSuperAdmin ? ['backup','api'] as const : [])]
}
export function canOpenSettings(auth:Access) { return settingsTabs(auth).length > 0 }
export function resolveSettingsTab(value:unknown, auth:Access):SettingsTab|undefined {
  const tabs=settingsTabs(auth)
  return tabs.includes(value as SettingsTab) ? value as SettingsTab : tabs[0]
}
export const legacyInstallLocation = (query:Record<string,unknown>={}) => ({ path:'/settings/system',query:{...query,tab:'install'} })
